import { Outlet, useMatches } from "@tanstack/react-router";

import { useSession } from "@/app/session";
import { AppShell } from "@/app/shell/AppShell";
import { useDocumentMeta } from "@/brand";
import { SiteFrame } from "@/site/SiteFrame";

/**
 * Layout for pages that work signed out (the RA directory). Signed in, it is
 * the normal app shell; signed out, the public site's header and footer.
 */
export function PublicLayout() {
  const session = useSession();
  if (session.status === "signed-in") return <AppShell />;
  return <PublicFrame />;
}

function PublicFrame() {
  const matches = useMatches();
  const title = [...matches].reverse().find((m) => m.staticData?.title)
    ?.staticData.title;
  useDocumentMeta(title);

  return (
    <SiteFrame ticker>
      <Outlet />
    </SiteFrame>
  );
}
